import { Component, ElementRef, ViewChild, Input, OnInit, OnDestroy, Renderer } from '@angular/core';

import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../services/user.service';
import { ModalService } from '../modal/modal.service';

import { User } from '../../models/user';

@Component({
    selector: 'app-topnav',
    templateUrl: './topnav.component.html',
    styleUrls: ['./topnav.component.css']
})

export class TopnavComponent implements OnInit, OnDestroy {
    @Input('notifications') notifications: number;

    public profileImage = "";

    public logoImage = "";

    @ViewChild('searchInput') searchInput: ElementRef;
    @ViewChild('searchIconContainer') searchIconContainer: ElementRef;
    @ViewChild('searchIcon') searchIcon: ElementRef;

    @ViewChild('notificationContainer') notificationContainer: ElementRef;
    @ViewChild('notificationIcon') notificationIcon: ElementRef;
    @ViewChild('notificationCount') notificationCount: ElementRef;

    @ViewChild('userProfile') userProfile: ElementRef;
    @ViewChild('userDropDown') userDropDown: ElementRef;

    user: User;
    // userName: string;

    constructor(private renderer: Renderer, public auth: AuthService, private modalService: ModalService, private userService: UserService) {
        modalService.modal$.subscribe((modal) => {
          if (modal.modalName == 'edit-profileClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
            this.profileImage = localStorage.getItem('profilePhotoPath') !== 'null' ? "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('profilePhotoPath') : 'https://web234.hvsfinancial.com/portal-shared/anon_user.png';
            this.logoImage = localStorage.getItem('logoPhotoPath') !== 'null' ? "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/portal-shared/logo.png';
            this.user.firstName = localStorage.getItem('firstName');
            this.user.lastName =  localStorage.getItem('lastName');
            // console.log(this.user);
          } 
        });

        this.notifications = 5;
    }

    ngOnInit() {
        this.user = this.userService.getUserInformation();
        this.profileImage = localStorage.getItem('profilePhotoPath') !== 'null' ? "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('profilePhotoPath') : 'https://web234.hvsfinancial.com/portal-shared/anon_user.png';
        this.logoImage = localStorage.getItem('logoPhotoPath') !== 'null' ? "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/portal-shared/logo.png';
    }

    searchFocus() {
        this.searchInput.nativeElement.placeholder = "";
        this.searchInput.nativeElement.style.color = "#555";
        this.searchIcon.nativeElement.style.color = "#555";
    }

    searchFocusOut() {
        this.searchInput.nativeElement.style.color = "#e0e0e0";
        this.searchIcon.nativeElement.style.color = "#555";
    }

    handleNotificationClick(e) {
        
    }

    handleSearch(e) {
        
    }

    handleUserNav(e) {
        if (this.userDropDown.nativeElement.classList.contains('dropdown-visible')) {
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-visible', null);
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-hidden', true);
        } else if (this.userDropDown.nativeElement.classList.contains('dropdown-hidden')) {
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-hidden', null);
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-visible', true);
        } else {
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-visible', true);
        }
    }

    handleContactUsModal(e) {
        this.modalService.add('contact-support', { ID: Number(localStorage.getItem("userId"))});
    }

    handleEditProfileModal(e) {
        this.modalService.add('edit-profile', { ID: Number(localStorage.getItem("userId"))});
    }

    handleSettingsModal(e) {
        this.modalService.add('settings', { ID: Number(localStorage.getItem("userId"))});
    }

    logout() {
        this.auth.logout();
    }

    ngOnDestroy() {
    }
}
